import { createFileRoute, redirect } from '@tanstack/react-router'

import { LoadingScreen } from '@/components/block/common/loading-screen'
import { AppLayout } from '@/components/layout/app-layout'

import { checkIsAuthenticated } from '@/lib/auth'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ preload, location }) => {
    if (preload) return null

    const isAuthenticated = await checkIsAuthenticated()
    if (!isAuthenticated) {
      const { pathname } = location

      throw redirect({
        to: '/auth/login',
        replace: true,
        search: { redirectTo: pathname },
      })
    }
  },
  pendingComponent: LoadingScreen,
  component: AppLayout,
})
